import {
  TypedUseSelectorHook,
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from 'react-redux';

import store from '../store';
import useDatesImport from './useDates';
import useDebounceImport from './useDebounce';
import useFormDataImport from './useFormData';
import useI18nImport from './useI18n';
import useIntervalImport from './useInterval';
import useWindowSizeImport from './useWindowSize';
import State from '../types/state';
export { useCurrency } from './useCurrency';
export * from './useLogger';

export const useWindowSize = useWindowSizeImport;

export const useFormData = useFormDataImport;

export const useDebounce = useDebounceImport;

export const useInterval = useIntervalImport;

export const useSelector: TypedUseSelectorHook<State> = useReduxSelector;

export const useI18n = useI18nImport;

export type Dispatch = typeof store.dispatch;

export const useDispatch = () => useReduxDispatch<Dispatch>();

export const useDates = useDatesImport;
